import { useState } from 'react';
import { useSelectedCategory, useIsLoggedIn, useSetSelectedCategory } from '../../../store/appStore';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { useBiLogger } from '../../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../../hooks/useBiLogger/biConstants';
import { RANDOM_CATEGORY, getRandomCategory } from '@common/constants/categories';
import { useSpec } from '../../../hooks/useSpec';
import { SelectThemeFirst } from '../../../experiments';
import { TEMPLATE_SELECTION_URL } from '../../../consts';

export const useSaveCategoryValue = () => {
  const [isLoading, setIsLoading] = useState(false);
  const categoryValue = useSelectedCategory();
  const setCategoryValue = useSetSelectedCategory();
  const { navigate } = useAppNavigation();
  const biLogger = useBiLogger();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);
  const isLoggedIn = useIsLoggedIn();
  const { ACTION, BUTTON_NAME } = BI_CONSTANTS;

  const saveCategoryValue = async () => {
    setIsLoading(true);

    let finalCategoryValue = categoryValue;

    if (categoryValue === RANDOM_CATEGORY) {
      finalCategoryValue = getRandomCategory();
    }

    setCategoryValue(finalCategoryValue);

    if (isLoggedIn || shouldSelectThemeFirst) {
      biLogger.actionClicked({
        action: ACTION.CATEGORY_PAGE_NEXT_LOGGED_USER,
        button_name: BUTTON_NAME.NEXT,
        value: categoryValue,
      });
      navigate(TEMPLATE_SELECTION_URL);
    } else {
      biLogger.actionClicked({
        action: ACTION.CATEGORY_PAGE_NEXT_SIGNUP_USER,
        button_name: BUTTON_NAME.NEXT,
        value: categoryValue,
      });
      const url = new URL(window.location.href);
      window.location.href = `${window.location.pathname}${TEMPLATE_SELECTION_URL}${url.search}`;
    }

    setIsLoading(false);
  };

  return {
    saveCategoryValue,
    isLoading,
    categoryValue,
  };
};
